import { Dumbbell, UserCheck, Building2, Flame, Camera } from "lucide-react";
import SectionHeading, { Reveal } from "@/components/SectionHeading";
import { HIGHLIGHTS, IMAGES } from "@/data/content";

const ICONS = { Dumbbell, UserCheck, Building2, Flame };

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-[#0A0A0A] py-20 md:py-28 overflow-hidden">
      <span aria-hidden="true" className="pointer-events-none select-none absolute -top-6 right-0 font-heading text-[16rem] leading-none text-outline hidden lg:block">
        F12
      </span>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="About F12 Fitness"
          title="More Than A Gym."
          accent="A Fitness Lifestyle."
          align="left"
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <p className="text-base sm:text-lg leading-relaxed text-[#D1D1D1]">
              F12 FITNESS is a fitness destination built for people who want to become stronger,
              healthier, and more confident. With modern training facilities and a motivating
              environment, we help our members move closer to their fitness goals.
            </p>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {HIGHLIGHTS.map((h, i) => {
                const Icon = ICONS[h.icon];
                return (
                  <Reveal key={h.title} delay={i * 0.08}>
                    <div
                      data-testid={`about-highlight-${i + 1}`}
                      className="bg-[#141414] border border-white/10 rounded-lg p-5 h-full transition-all duration-300 hover:border-[#FF5A1F]/60 hover:shadow-[0_10px_30px_rgba(255,90,31,0.12)]"
                    >
                      <Icon className="w-7 h-7 text-[#FF5A1F] mb-3" strokeWidth={2.25} />
                      <h3 className="font-heading text-xl tracking-wider text-white uppercase">
                        {h.title}
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-[#D1D1D1]">{h.text}</p>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-3 border-2 border-[#FF5A1F]/50 rounded-xl translate-x-4 translate-y-4" />
              <img
                src={IMAGES.about}
                alt="Sample photo of a modern gym interior — replace with an actual F12 FITNESS photograph"
                className="relative rounded-xl w-full aspect-[4/3] object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-4 left-4 right-4 bg-[#0A0A0A]/85 backdrop-blur-md border border-white/10 rounded-lg px-4 py-3 flex items-center gap-3">
                <Camera className="w-5 h-5 text-[#FF5A1F] shrink-0" />
                <p className="text-xs sm:text-sm text-[#D1D1D1]">
                  Sample photo — replace with your gym's actual photographs.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
